module.exports = __webpack_public_path__ + "assets/43a365d1abc1915f6e2e0a9023961cd8.mp3";